<template>
  <div class="patient-report-form">
    <div class="row">
      <div class="col-md-6">
        <label for="date_ini">Data Inicial</label>
        <input 
          v-model="formData.dateIni" 
          type="date" 
          id="date_ini" 
          class="form-control" 
          required
        >
      </div>
      <div class="col-md-6">
        <label for="date_end">Data Final</label>
        <input 
          v-model="formData.dateEnd" 
          type="date" 
          id="date_end" 
          class="form-control" 
          required
        >
      </div>
    </div>
    
    <div class="row mt-3">
      <div class="col-md-12">
        <label for="agreement">Convênio</label>
        <Multiselect
          v-model="formData.selectedAgreement"
          :options="listAgreements"
          :multiple="false"
          :close-on-select="true"
          :preserve-search="true"
          :show-labels="false"
          placeholder="Selecione um convênio"
          label="name"
          track-by="id"
          :searchable="true"
        />
      </div>
    </div>
    
    <div class="row mt-3">
      <div class="col-md-12 z-3">
        <label for="specialties">Tratamentos</label>
        <Multiselect
          v-model="formData.selectedSpecialties"
          :options="listSpecialties"
          :multiple="true"
          :close-on-select="false"
          :preserve-search="true"
          :show-labels="false"
          placeholder="Selecione os tratamentos (opcional)"
          label="name"
          track-by="id"
          :searchable="true"
        />
        <small class="text-muted mt-1">Deixe vazio para incluir todos os tratamentos</small>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "PatientReportForm",
  components: {
    Multiselect,
  },
  props: {
    listAgreements: {
      type: Array,
      default: () => []
    },
    listSpecialties: {
      type: Array,
      default: () => []
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        dateIni: this.initialData.dateIni || '',
        dateEnd: this.initialData.dateEnd || '',
        selectedAgreement: this.initialData.selectedAgreement || null,
        selectedSpecialties: this.initialData.selectedSpecialties || []
      }
    };
  },
  methods: {
    validate() {
      if (!this.formData.dateIni) {
        return { valid: false, message: 'Data inicial é obrigatória' };
      }
      if (!this.formData.dateEnd) {
        return { valid: false, message: 'Data final é obrigatória' };
      }
      if (!this.formData.selectedAgreement) {
        return { valid: false, message: 'Convênio é obrigatório' };
      }
      if (new Date(this.formData.dateIni) > new Date(this.formData.dateEnd)) {
        return { valid: false, message: 'Data inicial não pode ser maior que a data final' };
      }
      return { valid: true };
    },
    
    getFormData() {
      return {
        dateIni: this.formData.dateIni,
        dateEnd: this.formData.dateEnd,
        agreementId: this.formData.selectedAgreement?.id || '',
        specialtyIds: this.formData.selectedSpecialties.map(s => s.id)
      };
    }
  },
  watch: {
    initialData: {
      handler(newData) {
        this.formData = {
          dateIni: newData.dateIni || '',
          dateEnd: newData.dateEnd || '',
          selectedAgreement: newData.selectedAgreement || null,
          selectedSpecialties: newData.selectedSpecialties || []
        };
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.patient-report-form {
  padding: 10px 0;
}

.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 40px 0 8px;
}

.multiselect__input {
  background: transparent;
  border: none;
  outline: none;
}

.multiselect__content-wrapper {
  border: 1px solid #ced4da;
  border-top: none;
}

.multiselect__option--highlight {
  background: #007bff;
  color: white;
}

.multiselect__option--selected {
  background: #f8f9fa;
  color: #495057;
  font-weight: normal;
}

.multiselect__tag {
  background: #007bff;
  color: white;
}

.multiselect__tag-icon:hover {
  background: #0056b3;
}
</style>
